import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigateWithTransition } from '../../hooks/useNavigateWithTransition';

interface TransitionLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const TransitionLink: React.FC<TransitionLinkProps> = ({ 
  to, 
  children, 
  className = '', 
  style,
  onClick 
}) => {
  const navigateWithTransition = useNavigateWithTransition();
  const location = useLocation();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    
    // Execute any additional onClick handlers
    if (onClick) {
      onClick();
    }
    
    // Don't transition if we're already on the target page
    if (location.pathname === to) {
      return;
    }
    
    // Start the page transition
    navigateWithTransition(to);
  };

  return (
    <a
      href={to}
      className={className}
      style={style}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default TransitionLink; 